(function () {
    'use strict';

    angular.module('swif.reservations')
    .directive('reservationForm', reservationForm);

	function reservationForm (swif, openresa, swifOpenbaseCompanyService) {
		'ngInject';
        var ret = {
            restrict: 'E',
            transclude: false,
            require: 'ngModel',
            scope: {
                request: '=?',
                recurrenceParser: '=',
                createRecurrence: '=?',
                editRecurrence: '=?',
                readonly: '=?',
                onChangeDates: '&?',
                // onChangeLines: '&?'
            },
            link: link,
            templateUrl: 'partials/openresa/reservation-form-directive.html'
        };
        return ret;

        function link(scope, element, attr, ngModel) {

            scope._ = _;

            scope.rights = openresa.rights.getUserAbility();

            swifOpenbaseCompanyService.getGlobalSettingsResa().then(function(company) {
                scope.discountResaActivate = company.discountResa;
                scope.discountResa = swif.settings.app.features.discountResa && scope.discountResaActivate;
            });

            scope.isValidForm=false;
            scope.isValidBlockBooking=true;

            // compute the number of day in reservation
            const computeDayResa = () => {
                if (swif.settings.app.features.discountResa
                        && scope.proxy.booking.checkin !== undefined
                        && scope.proxy.booking.checkout !== undefined) {
                    var oneDay = 24*60*60*1000;
                    var firstDate = parseDate(scope.proxy.booking.checkin).getTime();
                    var secondDate = parseDate(scope.proxy.booking.checkout).getTime();

                    scope.proxy.booking.diffDays = Math.round(Math.abs((firstDate - secondDate)/(oneDay))) + 1;
                }
            };

            scope.getReservedQty = function (resource) {
                var line = _.find(scope.proxy.booking.lines, function (item) {
                    return item.resource.id === resource.id;
                });
                var ret = 0;
                if(line) {
                    ret = line.qty;
                }
                return ret;
            };

            scope.sortProdsAvailable  = function(dataObj) {
                var ret = _.sortByAll(_.values(dataObj), function (elt) {
                    return elt.option_of_product_ids ? elt.option_of_product_ids[0]: 0;
                });
                return ret;
            };

            scope.isOptionOf = function (bookable, currentBookableId) {
                if (currentBookableId) {
                    return _.contains(bookable.option_of_product_ids, currentBookableId);
                }
                return false;
            };

            scope.sync = function () {
                ngModel.$setViewValue(scope.proxy.booking);
            };

            scope.initialize = function () {
                scope.readonly = Boolean(scope.readonly);
                scope.discountResa = Boolean(scope.discountResa);
                scope.proxy = {booking: {}, occurrences: []};
                scope.proxy.fakeProduct = false;
                scope.proxy.resourceFilter = openresa.bookables.getResourceFilter();
                openresa.rights.getUserAbility(scope);
                scope.expand = {date: true, resources: true, recurrence: true};
                scope.addResource = openresa.bookables.addResource;
                ngModel.$render = function () {
                    var vv = ngModel.$viewValue;
                    if (vv) {
                        // keep reference of the given ngModel
                        scope.proxy.booking =  vv;
                        // by default, if not any expand is active, activate the 'date' exapand
                        if (!scope.expand.date && !scope.expand.resources && scope.expand.recurrence) {
                            scope.expand.date = true;
                        }
                        scope.proxy.prodsAvailable = openresa.bookables.getAllProdAvailable(scope.proxy.booking, scope.request);
                    }
                };
            };
            scope.initialize();

            /* @param line: (Object) line to remove from model
               @note: don't update anything to the server, only prepare model for the next save()
            */
            scope.removeLine = function (model, line) {
                var index = model.lines.indexOf(line);
                if(index >= 0) {
                    if(line.id) {
                        model.deleted_lines.push(line);
                    }
                    model.lines.splice(index, 1);
                    scope._sanitizeLinesOptions(model);
                }
            };

            /*
             * If some options does not have their required resources,
             * remove the options form the reservation
             * (mainly used when removing a line, it will remove all related options
             * if not any other line can make them available)
             */
            scope._sanitizeLinesOptions = function (model)  {
                // if we have to recheck the lines after the current sanitize, or not
                // (used to apply multiple deletion in case of cascade dependancies)
                var ok = true;
                var toRemove = [];
                var bookable_ids = [];
                _.forEach(model.lines, function(line) {
                    bookable_ids.push(line.resource.id);
                });
                // iterate over remaining lines, and remove the one where bookables
                // in options are not available since the last deletion(s)
                _.forEach(model.lines, function(line) {
                    if (line.resource.option_of_product_ids.length > 0 &&
                        _.intersection(line.resource.option_of_product_ids, bookable_ids).length <= 0) {
                        toRemove.push(line);
                        ok = false;
                    }
                });
                // i use this tmp array to keep the reference of the line(s),
                // so that removeLine still work in its current implementation
                // (it tries to retrieve the line to remove via the object reference)
                _.forEach(toRemove, function(item) {
                    scope.removeLine(model, item);
                });
                // some lines have been removed, check one more time to ensure
                // some options have not been unavailable due to these deletions
                if (!ok) {
                    scope._sanitizeLinesOptions(model);
                }
            };

            scope.addProduct = function () {
                if(scope.proxy.fakeProduct) {
                    openresa.bookables.addResource(scope.proxy.booking, scope.proxy.fakeProduct, 1, scope.request)
                        .then(function () {
                            scope.proxy.prodsAvailable = openresa.bookables.getAllProdAvailable(scope.proxy.booking, scope.request);
                        });
                    scope.proxy.fakeProduct = false;
                }
            };

            scope.wholeDaySwitch = function () {
                openresa.bookings._updateOnWholeDay(scope.proxy.booking);
            };

            scope.computeBlockingBooking = function (line){
                if(_.isUndefined(line)){
                  return;
                }

                scope.isValidBlockBooking = true;
                _.forEach(line, function(item) {
                    if(item && !item['_dispo'] && item['_block_booking']){
                        scope.isValidBlockBooking = false;
                    }
                });
            };

            // @TODO: swifChange
            scope.$watch('proxy.booking.lines', function (newV, oldV) {
                if(!angular.equals(newV, oldV)) {
                    // if some qties have been changed (or if we switch the activeBooking model),
                    // update the availability of booking
                    var oldVQties = _.pluck(oldV || [], 'qty');
                    var newVQties = _.pluck(newV || [], 'qty');
                    var oldVAvailability = _.pluck(oldV || [], 'available_qty');
                    var newVAvailability = _.pluck(newV || [], 'available_qty');

                    if (!angular.equals(newVQties, oldVQties) ||
                        !angular.equals(oldVAvailability, newVAvailability ||
                            newV !== oldV)) {
                        openresa.bookables._computeLineAvailability(scope.proxy.booking);
                    }

                    scope.proxy.booking._bookingNotice = _.min(newV, 'bookable_notice').bookable_notice;

                    var getProdIdsWithOptions = function (items) {
                        var ret = [];
                        _.forEach(items, function (item) {
                            if (item.resource) {
                                if (!_.isEmpty(item.resource.optional_product_ids)) {
                                    ret.push(item.resource.id);
                                }
                            }
                        });
                        return ret;
                    };

                    var oldProdIds = getProdIdsWithOptions(oldV);
                    var newProdIds = getProdIdsWithOptions(newV);

                    if (!angular.equals(newProdIds, oldProdIds)) {
                        // if some lines was added / removed,
                        // and if some lines was present in new or old values
                        scope.proxy.prodsAvailable = openresa.bookables.getAllProdAvailable(scope.proxy.booking, scope.request);
                    }
                    if (scope.discountResa) {
                        scope.proxy.booking.totalPeriodPP = 0;
                        scope.proxy.booking.totalPeriodPuj = 0;
                        scope.proxy.booking.totalDiscountPercentPP = 0;
                        scope.proxy.booking.totalDiscountPercentPuj = 0;
                        scope.proxy.booking.totalDiscountEurosPeriodPP = 0;
                        scope.proxy.booking.totalDiscountEurosPeriodPuj = 0;
                        scope.proxy.booking.dailyTotalDiscountPeriod = 0;

                        const nbDays = scope.proxy.booking.diffDays;
                        let sommeProdA = 0;
                        let sommeProdB = 0;
                        let sommeProdC = 0;
                        let sommeProdD = 0;

                        _.forEach(newV, function (line, index) {

                            if (line.discount_pp < 0 || line.discount_pp === undefined) {
                                line.discount_pp = 0;
                            }
                            if (line.discount_puj < 0 || line.discount_puj === undefined ) {
                                line.discount_puj = 0;
                            }
                            if (line.discountEuroPP < 0 || line.discountEuroPP === undefined) {
                                line.discountEuroPP = 0;
                            }
                            if (line.discountEuroPuj < 0 || line.discountEuroPuj === undefined) {
                                line.discountEuroPuj = 0;
                            }
                            if (line.discount_pp > 100 ) {
                                line.discount_pp = 100;
                            }
                            if (line.discount_puj > 100 ) {
                                line.discount_puj = 100;
                            }
                            if (line.discountEuroPP > line.package_price) {
                                line.discountEuroPP = angular.copy(line.package_price);
                            }
                            if (line.discountEuroPuj > line.puj) {
                                line.discountEuroPuj = angular.copy(line.puj);
                            }

                            scope.proxy.booking.totalPeriodPP += line.package_price * line.qty;
                            scope.proxy.booking.totalPeriodPuj += line.puj * line.qty;

                            line.periodDiscountedPrice = ((1 - line.discount_pp / 100) * line.qty * line.package_price) + ((1 - line.discount_puj / 100) * line.qty * line.puj * nbDays);

                            sommeProdA += line.qty * line.package_price;
                            sommeProdB += line.qty * line.package_price * line.discount_pp;

                            sommeProdC += line.qty * line.puj;
                            sommeProdD += line.qty * line.puj * line.discount_puj;

                            if (scope.proxy.booking.isPercent) {
                                line.discountEuroPP = line.package_price * line.discount_pp / 100;
                                line.discountEuroPuj = line.puj * line.discount_puj / 100;
                            } else {
                                line.discount_pp = Math.round(line.discountEuroPP * 100 / line.package_price);
                                line.discount_puj = Math.round(line.discountEuroPuj * 100 / line.puj);
                            }
                            line.periodDiscountedPrice = Math.round(line.periodDiscountedPrice * 100) / 100;
                            scope.proxy.booking.dailyTotalDiscountPeriod += line.periodDiscountedPrice;
                            line.discountEuroPP = Math.round(line.discountEuroPP * 100) / 100;
                            line.discountEuroPuj = Math.round(line.discountEuroPuj * 100) / 100;

                            if (Number.isNaN(line.discount_pp)){
                                line.discount_pp = 0;
                            }
                            if (Number.isNaN(line.discount_puj)){
                                line.discount_puj = 0;
                            }
                            if (Number.isNaN(line.periodDiscountedPrice)){
                                line.periodDiscountedPrice = 0;
                            }
                        });

                        scope.proxy.booking.totalPeriodPuj = scope.proxy.booking.totalPeriodPuj * nbDays;

                        scope.proxy.booking.totalDiscountPercentPP = 1 - ((sommeProdA - sommeProdB) / sommeProdA);
                        scope.proxy.booking.totalDiscountEurosPeriodPP = scope.proxy.booking.totalPeriodPP * scope.proxy.booking.totalDiscountPercentPP / 100;

                        scope.proxy.booking.totalDiscountPercentPuj = 1 - (((nbDays * sommeProdC) - (nbDays * sommeProdD)) / (nbDays * sommeProdC));
                        scope.proxy.booking.totalDiscountEurosPeriodPuj = scope.proxy.booking.totalPeriodPuj * scope.proxy.booking.totalDiscountPercentPuj / 100;

                        scope.proxy.booking.totalDiscountPercentPP = Math.round(scope.proxy.booking.totalDiscountPercentPP * 100) / 100;
                        scope.proxy.booking.totalDiscountEurosPeriodPP = Math.round(scope.proxy.booking.totalDiscountEurosPeriodPP * 100) / 100;
                        scope.proxy.booking.totalDiscountPercentPuj = Math.round(scope.proxy.booking.totalDiscountPercentPuj * 100) / 100;
                        scope.proxy.booking.totalDiscountEurosPeriodPuj = Math.round(scope.proxy.booking.totalDiscountEurosPeriodPuj * 100) / 100;

                        if (Number.isNaN(scope.proxy.booking.totalDiscountPercentPP) || Number.isNaN(scope.proxy.booking.totalDiscountEurosPeriodPP)) {
                            scope.proxy.booking.totalDiscountPercentPP = 0;
                            scope.proxy.booking.totalDiscountEurosPeriodPP = 0;
                        }
                        if (Number.isNaN(scope.proxy.booking.totalDiscountPercentPuj) || Number.isNaN(scope.proxy.booking.totalDiscountEurosPeriodPuj)) {
                            scope.proxy.booking.totalDiscountPercentPuj = 0;
                            scope.proxy.booking.totalDiscountEurosPeriodPuj = 0;
                        }
                    }
                }

                scope.computeBlockingBooking(newV);

                // a claimer can't make a booking if the resource isn't available and block
                // and we don't allow a multiple booking if one booking don't respect this rule
                scope.isValidForm = scope.isValidBlockBooking;
                if (scope.rights.is.external){
                    scope.request.bookings.forEach(function (booking) {
                        booking.lines.forEach(function (line) {
                            var blocking_line = line.resource && line.resource.block_booking;
                            if (!line._dispo && blocking_line){
                                scope.isValidForm = false;
                            }
                        });
                    });
                }

                if (scope.rights.is.external || scope.rights.is.internalUser) {
                    // on récupère le plus petit préavis (= notice)
                    var minBookableNotice = null;
                    scope.request.bookings.forEach(function (booking) {
                        booking.lines.forEach(function (line) {
                            if (line.resource) {
                                // depends if claimer is internal or external
                                if (scope.rights.is.internalUser) {
                                    line.resource._bookableNotice = line.resource.internal_bookable_notice;
                                } else if (scope.rights.is.external) {
                                    line.resource._bookableNotice = line.resource.external_bookable_notice;
                                }
                                if (minBookableNotice === null){
                                    minBookableNotice = line.resource._bookableNotice;
                                }else if (line.resource._bookableNotice > minBookableNotice){
                                    minBookableNotice = line.resource._bookableNotice;
                                }
                            }
                        });
                        var minDatetimeNotice = moment.utc();
                        minDatetimeNotice.add(minBookableNotice, 'day');
                        minDatetimeNotice.set('minute', 0);
                        minDatetimeNotice.set('second', 0);
                        minDatetimeNotice.set('millisecond', 0);
                        scope.minDatetimeNotice = minDatetimeNotice;
                    });
                    scope.minBookableNotice = minBookableNotice;
                }
                // Sort lines
                if (scope.proxy.booking.lines && scope.proxy.booking.lines.length) {
                    scope.proxy.booking.lines = _.sortBy(scope.proxy.booking.lines, line => {
                        if (line.resource && line.resource.type_prod) {
                            return line.resource.type_prod;
                        }
                    });
                }

            }, true);

            scope.$watch('proxy.booking', function (newV, oldV) {
                setTimeout(() => {
                    if (scope.discountResa) {
                        computeDayResa();
                        if (Number.isNaN(newV.totalDiscountEurosPeriodPP) || newV.totalDiscountEurosPeriodPP === undefined) {
                            scope.proxy.booking.totalDiscountEurosPeriodPP = 0;
                        }
                        if (Number.isNaN(newV.totalDiscountEurosPeriodPuj) || newV.totalDiscountEurosPeriodPuj === undefined) {
                            scope.proxy.booking.totalDiscountEurosPeriodPuj = 0;
                        }
                        if (Number.isNaN(newV.totalDiscountPercentPP) || newV.totalDiscountPercentPP === undefined) {
                            scope.proxy.booking.totalDiscountPercentPP = 0;
                        }
                        if (Number.isNaN(newV.totalDiscountPercentPuj) || newV.totalDiscountPercentPuj === undefined) {
                            scope.proxy.booking.totalDiscountPercentPuj = 0;
                        }
                        if (Number.isNaN(newV.dailyTotalDiscountPeriod) || newV.dailyTotalDiscountPeriod === undefined) {
                            scope.proxy.booking.dailyTotalDiscountPeriod = 0;
                        }
                        if (Number.isNaN(scope.proxy.booking.totalPeriodPP) || scope.proxy.booking.totalPeriodPP === undefined) {
                            scope.proxy.booking.totalPeriodPP = 0;
                        }
                        if (Number.isNaN(scope.proxy.booking.totalPeriodPuj) || scope.proxy.booking.totalPeriodPuj === undefined) {
                            scope.proxy.booking.totalPeriodPuj = 0;
                        }
                        _.forEach(newV.lines, function (line, index) {
                            scope.proxy.booking.totalPeriodPP += line.package_price * line.qty;
                            scope.proxy.booking.totalPeriodPuj += line.puj * line.qty;
                            if (line.discount_pp < 0 || line.discount_pp === undefined) {
                                line.discount_pp = 0;
                            }
                            if (line.discount_puj < 0 || line.discount_puj === undefined ) {
                                line.discount_puj = 0;
                            }
                            if (line.discountEuroPP < 0 || line.discountEuroPP === undefined) {
                                line.discountEuroPP = 0;
                            }
                            if (line.discountEuroPuj < 0 || line.discountEuroPuj === undefined) {
                                line.discountEuroPuj = 0;
                            }
                        });
                    }
                }, 500);
            });

            scope.$watchGroup(['proxy.booking.checkin', 'proxy.booking.checkout'], function (newV, oldV) {
                if(!angular.equals(newV, oldV)) {
                    var newCheckIn = newV[0];
                    var newCheckOut = newV[1];
                	var ok = newCheckIn && newCheckOut;
                	// only on initialization, if checkout has never been set:
                	//  set date to checkin + 2 hours
                	if (_.isUndefined(newCheckOut) && newCheckIn) {
                        var checkout = moment.utc(newCheckIn).add(2, 'hours');
                        scope.proxy.booking.checkout = checkout.format('YYYY-MM-DD HH:mm:ss');;
                        ok = true;
                    }
                    if(ok && (scope.proxy.booking.fetched || !scope.proxy.booking.id)) {
                        scope.proxy.prodsAvailable = openresa.bookables.getAllProdAvailable(scope.proxy.booking, scope.request);
                        openresa.bookables._recheckResources(scope.proxy.booking, scope.request);
                    }
                    if (scope.onChangeDates) {
                        scope.onChangeDates({
                            checkin: scope.proxy.booking.checkin,
                            checkout: scope.proxy.booking.checkout
                        });
                    }
                    computeDayResa();
                    scope.computeBlockingBooking(newV);
                }
            });

            function parseDate(input) {
              var parts = input.match(/(\d+)/g);
              // new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
              return new Date(parts[0], parts[1]-1, parts[2]); // months are 0-based
            }
        }
    }

})();
